<div class="details-wrapper">
  <a
    class="show-details-link"
    (click)="showDetails = !showDetails"
    (keydown.enter)="showDetails = !showDetails"
    tabindex="0"
    role="button"
    [attr.aria-expanded]="showDetails"
  >
    <span i18n="@@basketPanelTotalShowDetails">Show details</span>
    <span class="sr-only"> for {{ detail?.vendorName }} car</span>
    <i
      class="ico"
      [class.ico-chevron-down]="!showDetails"
      [class.ico-chevron-up]="showDetails"
      aria-hidden="true"
    ></i>
  </a>
  @if (showDetails) {
    <div class="summary">
      <dl>
        @if (detail?.identifiers?.vehType; as vehType) {
          <div>
            <dt><strong i18n="@@ShowDetailsVehicle">Vehicle:</strong></dt>
            <dd>{{ vehType }}</dd>
          </div>
        }
        @if (detail?.car; as car) {
          @if (car?.class) {
            <div>
              <dt><strong i18n="@@itineraryCategory">Category:</strong></dt>
              <dd>{{ car.class }}</dd>
            </div>
          }
          @if (car?.type) {
            <div>
              <dt><strong i18n="@@itineraryType">Type:</strong></dt>
              <dd>{{ searchParams.getCarTypeForDisplay(car.type) }}</dd>
            </div>
          }
        }
      </dl>
    </div>
  }
</div>
